import React, { Component } from 'react';
import { List, Modal } from 'semantic-ui-react';
import PropTypes from 'prop-types';

class HLBCampaignTncModal extends Component {
  static propTypes = {
    onClose: PropTypes.func,
  }
  static getPropsToState = (props) => {
    const open = props.open;
    return {
      open,
    };
  }
  constructor(props) {
    super(props);
    const state = HLBCampaignTncModal.getPropsToState(props);
    this.state = {
      ...state,
    };
  }
  componentWillReceiveProps(nextProps) {
    const state = HLBCampaignTncModal.getPropsToState(nextProps);
    this.setState({ ...state });
  }
  handleOnClose = () => {
    this.props.onClose();
  }

  render() {
    const { open } = this.state;
    return (
      <Modal
        size="large"
        open={open}
        onClose={this.handleOnClose}
        closeIcon="close"
      >
        <Modal.Content className="hlb-campaign-terms-modal-content">
          <Modal.Description>
            <div className="hlb-campaign-main-banner">
              <h2 className="hlb-campaign-main-banner-title">Terms & Conditions</h2>
              <span className="hlb-campaign-main-banner-subtitle" style={{ marginBottom: '20px' }}>MHub Loan Tracker Campaign</span>
            </div>
          </Modal.Description>
          <Modal.Description style={{ marginTop: '2em' }}>
            <p className="header">Terms and Conditions</p>
            <p className="title">Campaign period</p>
            <List bulleted>
              <List.Item>
                The Campaign starts of the 28th of Aug and ends on 31st Dec 2025
              </List.Item>
            </List>
          </Modal.Description>
          <Modal.Description style={{ marginTop: '1em' }}>
            <p className="title">Campaign</p>
            <List bulleted>
              <List.Item>
                Cases sent to HLB through TRB Ventures Sdn Bhd Showroom during this period will qualify for cash payout
                Cases sent to HLB through TRB Ventures Sdn Bhd Showroom during this period will qualify
                for cash payout
              </List.Item>
            </List>
          </Modal.Description>
          <Modal.Description style={{ marginTop: '1em' }}>
            <p className="title">Eligibility</p>
            <List bulleted>
              <List.Item>
                Only agents that have access to MHub Showroom in Malaysia can participate
              </List.Item>
              <List.Item>
                Only applicable to bookings under Booked/Reserved status
              </List.Item>
              <List.Item>
                Only applicable to bookings made during the campaign period
              </List.Item>
              <List.Item>
                Bookings cannot be made under the property agent’s name. Any agent wishing to book a
                property in his or her own name, under a genuine transaction must write to TRB Ventures
                Sdn Bhd to seek eligibility to add the booking. Requests can be sent to victor@mhub.my
              </List.Item>
              <List.Item>
                Participants cannot be related to TRB Ventures Sdn Bhd management staff
              </List.Item>
              <List.Item>
                Only valid for projects prequalified by the TRB Ventures Sdn Bhd
              </List.Item>
              <List.Item>
                TRB Ventures Sdn Bhd reserve the right to deduct bank transaction fees for the cash
                payout
              </List.Item>
            </List>
          </Modal.Description>
          <Modal.Description style={{ marginTop: '1em' }}>
            <p className="title">Cash payout</p>
            <List bulleted>
              <List.Item>
                RM10 will be paid to agents who submit cases (with the consent of the purchaser) to HLB
                through TRB Ventures Sdn Bhd Showroom exclusively. Agents who submit it to HLB through
                TRB Ventures Sdn Bhd Showroom as well as directly to HLB will not be eligible for the
                cash payout
              </List.Item>
              <List.Item>
                TRB Ventures Sdn Bhd will transfer the payment to eligible agents every 15th and 30th of
                the month
              </List.Item>
              <List.Item>
                Qualifying agents must submit their bank details to TRB Ventures Sdn Bhd to receive
                payout. Payment is deemed to have been made once TRB Ventures Sdn Bhd has made the
                transfer even if the agent does not receive the payment
              </List.Item>
            </List>
          </Modal.Description>
          <Modal.Description style={{ marginTop: '1em' }}>
            <p className="title">Disqualification</p>
            <List bulleted>
              <List.Item>
                Without prejudice to any right which TRB Ventures Sdn Bhd may have in law, TRB Ventures Sdn Bhd reserves the right at its sole discretion to disqualify any Eligible Participant(s) and/or forfeit any reward from the Eligible Participant who:
              </List.Item>
            </List>
            <List as="ul">
              <List.Item>
                i. TRB Ventures Sdn Bhd determines to be tampering with the entry process or the operation of the Campaign, or to be acting in breach or potential breach of this Terms and Conditions; or
              </List.Item>
              <List.Item>
                ii. TRB Ventures Sdn Bhd believes has undertaken fraudulent practice and/or activities or other activities harmful to this Campaign or the Campaign submission process. Fraudulent activities are deemed to include but not be limited to any act of deceit and/or deception and/or cheating.
              </List.Item>
            </List>
          </Modal.Description>
          <Modal.Description style={{ marginTop: '1em' }}>
            <p className="title">Variation</p>
            <List bulleted>
              <List.Item>
                TRB Ventures Sdn Bhd reserve the right to vary the terms of the campaign including the amount of cash payout and prizes awarded
              </List.Item>
              <List.Item>
                Where the prizes announced no longer is available for TRB Ventures Sdn Bhd to purchase TRB Ventures Sdn Bhd reserves the right to choose a substitute of similar value
              </List.Item>
            </List>
          </Modal.Description>
          <Modal.Description style={{ marginTop: '1em' }}>
            <p className="title">TRB Ventures Sdn Bhd&apos;s decision</p>
            <List bulleted>
              <List.Item>
                All decisions made by TRB Ventures Sdn Bhd relating to or in connection with the Campaign including and without limitation, the process and manner the entries are judged shall be final and no appeal, query or correspondence shall be entertained.
              </List.Item>
              <List.Item>
                TRB Ventures Sdn Bhd will transfer the payment to eligible agents every 15th and 30th of
                the month
              </List.Item>
              <List.Item>
                Qualifying agents must submit their bank details to TRB Ventures Sdn Bhd to receive
                payout. Payment is deemed to have been made once TRB Ventures Sdn Bhd has made the
                transfer even if the agent does not receive the payment
              </List.Item>
            </List>
          </Modal.Description>
          <Modal.Description style={{ marginTop: '1em' }}>
            <p className="title">Usage of Participants Data and Image</p>
            <List bulleted>
              <List.Item>
                By participating in this Campaign, Eligible Participant agrees to be bound by these terms and conditions and consent to allow his/her personal data being collected, processed and used by TRB Ventures Sdn Bhd in accordance with TRB Ventures Sdn Bhd Privacy Notice stipulated in the Appendix 1 (“Privacy Notice”).
              </List.Item>
            </List>
            <List as="ul" >
              <List.Item >
                * Subject to the Privacy Notice, by participating in this contest, each Eligible Participant agrees that all details submitted pursuant to this Campaign, including without limitation personal data/
                information being collected, processed and used by TRB Ventures Sdn Bhd for:
              </List.Item>
              <List.Item>
                ** The purpose of this Campaign such as marketing and promotional activities conducted in such manner as TRB Ventures Sdn Bhd sees fit nationwide or worldwide in any media including
                without limitation to the internet, without further express consent from, and payment or consideration to the relevant Eligible Participants.
              </List.Item>
              <List.Item>
                *** Marketing and promotional activities include without limitation the use and/or publication of any details provided in and/or in connection to the entries, interview material as well responses
                and related photographs.
              </List.Item>
              <List.Item>
                **** The winner expressly grant permission to TRB Ventures Sdn Bhd and its agencies or partners to use the winner’s name, photograph and/or likeness for purposes of advertising, editorial,
                promotional, marketing, trade and/or other purposes without further compensation and notice.
              </List.Item>
            </List>
          </Modal.Description>
          <Modal.Description style={{ marginTop: '1em', marginBottom: '2em' }}>
            <p className="title">General Terms</p>
            <List bulleted>
              <List.Item>
                TRB Ventures Sdn Bhd reserves the right to cancel, terminate or suspend the Campaign without any prior notice and reason. For the avoidance of doubt, any cancellation, termination or suspension by TRB Ventures Sdn Bhd of this contest shall not entitle the participant to any claim or compensation against TRB Ventures Sdn Bhd for any or all losses or damages suffered or incurred as a direct or indirect result of the act of cancellation, termination or suspension.
              </List.Item>
            </List>
            <List as="ul" >
              <List.Item>
                * In the event of any inconsistency between these Terms and Conditions and any advertising, promotional, publicity and other materials relating to or in connection with the Campaign, these
                Terms and Conditions shall prevail.
              </List.Item>
              <List.Item>
                ** This Campaign can only be used for single transaction, normal priced items and cannot be bundled with other ongoing promotions
              </List.Item>
              <List.Item>
                ***  This Campaign cannot be stacked with other voucher, or promotion codes.
              </List.Item>
            </List>
            <List bulleted>
              <List.Item>
                Each buyer is eligible for only one payment. If the same customer switches units and the agent resubmits the case, or if the agent selects both Hong Leong Bank and Hong Leong Islamic Bank for the same customer, the organizer will consider it as a single referral qualifying for payment.
	            </List.Item>
              <List.Item>
                If the payment date falls on a public holiday, payment will be processed on the next working day.
	            </List.Item>
              <List.Item>
                Cases submitted after 10:00 AM on the 12th or 25th of the month will be included in the next payment cycle.
              </List.Item>
            </List>
          </Modal.Description>
        </Modal.Content>
      </Modal>
    );
  }
}

export default HLBCampaignTncModal;



// WEBPACK FOOTER //
// ./src/components/HLBCampaign/HLBCampaignTncModal.jsx